import {
    instance
} from '../../util/http'
import apis from '../../config/apis'

const getDefault = () => {
    return instance.get(apis.Address.getDefault)
}

const addAddress = ({
    addressDetail,
    city,
    county,
    isDefault,
    name,
    province,
    tel,
    areaCode
}) => {
    return instance.post(apis.Address.Post, {
        name: name,
        cellPhone: tel,
        province: province,
        city: city,
        district: county,
        details: addressDetail,
        isDefault: isDefault,
        districtCode: areaCode
    })
}
const getAddress = (page, limit) => {
    return instance.get(apis.Address.Get + "?page=" + page + "&limit=" + limit )

}

const getAddressDetail = (id) => {
    return instance.get(apis.Address.Detail + "?addressid=" + id)
}
const deleteAddress = (id) => {
    return instance.delete(apis.Address.Delete, {
        data: { 
            id: id
        }
    })
}

const updateAddress = ({
    id,
    addressDetail,
    city,
    county,
    isDefault,
    name,
    province,
    tel,
    areaCode
}) => {
    return instance.put(apis.Address.Put, {
        name: name,
        cellPhone: tel,
        province: province,
        city: city,
        district: county,
        details: addressDetail,
        isDefault: isDefault,
        districtCode: areaCode,
        id: id,
    })
}
export default {
    getDefault,
    addAddress,
    getAddress,
    getAddressDetail,
    deleteAddress,
    updateAddress
}